import React, { useState, useRef, useEffect } from "react";
import { useIonToast, IonIcon } from "@ionic/react";
import { image } from "ionicons/icons";
const ImageChooser: React.FC<{ onSaveImage: (image: string) => void }> = ({
  onSaveImage,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!previewUrl && fileInputRef.current) {
      const timer = setTimeout(() => {
        fileInputRef.current?.click();
      }, 500); // Small delay to ensure component is fully rendered
      return () => clearTimeout(timer);
    }
  }, [previewUrl]);

  const [present] = useIonToast();

  // Send previewUrl to parent whenever it changes
  useEffect(() => {
    if (previewUrl) {
      onSaveImage(previewUrl);
    }
  }, [previewUrl, onSaveImage]);
  const showToastMessage = (
    message: string,
    color: "danger" | "success" = "danger"
  ) => {
    present({
      message,
      duration: 2000,
      position: "bottom",
      color,
    });
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      showToastMessage("No file selected");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showToastMessage(
        "Image size too large. Please select an image under 5MB."
      );
      return;
    }

    if (!file.type.startsWith("image/")) {
      showToastMessage("Please select a valid image file.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result as string);
      onSaveImage(reader.result as string);
    };
    reader.onerror = () => {
      showToastMessage("Failed to read the image file");
    };
    reader.readAsDataURL(file);
  };

  if (previewUrl) {
    return null;
  }

  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100% - 100px)",
      }}
      onClick={() => fileInputRef.current?.click()}
    >
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleImageUpload}
      />
      <div
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          backgroundColor: "#e0e0e0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <IonIcon
          icon={image}
          style={{
            width: "50px",
            height: "50px",
            color: "#888",
          }}
        />
      </div>
      <p
        style={{
          fontSize: "17px",
          color: "#555",
          margin: "0",
        }}
      >
        Tap to select a profile photo
      </p>
    </div>
  );
};

export default ImageChooser;
